module.exports = __webpack_public_path__ + "img/ebcKrW.82e8a18c.svg";